import { render, staticRenderFns } from "./RecentlyAddedJumps.vue?vue&type=template&id=1ed91f58&"
import script from "./RecentlyAddedJumps.vue?vue&type=script&lang=js&"
export * from "./RecentlyAddedJumps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed91f58')) {
      api.createRecord('1ed91f58', component.options)
    } else {
      api.reload('1ed91f58', component.options)
    }
    module.hot.accept("./RecentlyAddedJumps.vue?vue&type=template&id=1ed91f58&", function () {
      api.rerender('1ed91f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/RecentlyAddedJumps.vue"
export default component.exports